var _excluded = ["active", "value", "onChange", "onOpen", "onClose"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import ChromePicker from 'react-color/lib/Chrome';
import { noop, useToggle } from '../utils';

/**
 *
 * @name ColorPicker
 * @type Function
 * @description A control component for picking a hex color value. Built using the [react-color](https://casesandberg.github.io/react-color/) `ChromePicker`.
 * @param {String} [value] - The hex value of the selected color
 * @param {Function} [onChange] - A function called with the new hex value when a color is selected
 * @param {Function} [onOpen] A function called when the picker is expanded
 * @param {Function} [onClose] A function called when the picker is closed
 * @param {Boolean} [active] - A boolean that controls whether the picker is expanded or not.
 * @example
 *
 * function BackgroundSetter ({ backgroundColor, setBackgroundColor }) {
 *   return (
 *     <div>
 *       <h1> Set background color </h1>
 *       <ColorPicker
 *         value={ backgroundColor }
 *         onChange={ setBackgroundColor }
 *       />
 *     </div>
 *   )
 * }
 *
 */

var propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  active: PropTypes.bool
};
var defaultProps = {
  value: '#000000',
  onChange: noop,
  onOpen: noop,
  onClose: noop
};
function ColorPicker(_ref) {
  var active = _ref.active,
    value = _ref.value,
    _onChange = _ref.onChange,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useToggle = useToggle(),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    expanded = _useToggle2[0],
    toggleExpanded = _useToggle2[1];
  var isExpanded = active === undefined ? expanded : active;
  return /*#__PURE__*/React.createElement("div", {
    className: "color-picker"
  }, /*#__PURE__*/React.createElement("span", {
    className: "swatch",
    style: {
      background: value || 'black'
    },
    onClick: function onClick() {
      toggleExpanded();
      return onOpen();
    }
  }), isExpanded && /*#__PURE__*/React.createElement("div", {
    className: "popover"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cover",
    onClick: function onClick() {
      toggleExpanded();
      return onClose();
    }
  }), /*#__PURE__*/React.createElement(ChromePicker, _extends({
    color: value,
    onChange: function onChange(_ref2) {
      var hex = _ref2.hex;
      return _onChange(hex);
    },
    disableAlpha: true
  }, rest))));
}
ColorPicker.propTypes = propTypes;
ColorPicker.defaultProps = defaultProps;
export default ColorPicker;